<template>
    <div @click="lockScreen" class="lock-screen-btn-con">
        <Tooltip :content="$_t().main.lock" placement="bottom">
            <Icon type="md-lock" :size="20"/>
        </Tooltip>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'lockScreen',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        ...mapMutations('app', ['setLockInfo']),
        lockScreen() {
            let lockScreenBack = document.querySelector('.lock-screen-back');
            lockScreenBack.style.zIndex = 10000;
            lockScreenBack.style.boxShadow = '0 0 0 2000px #667aa6 inset';
            this.setLockInfo({ routerName: this.$route.name, isLock: true });
            setTimeout(() => {
                this.$router.push({ name: 'locking' });
            }, 800);
        },
    },
};
</script>

<style lang="less" scoped>
.lock-screen-btn-con {
    display: inline-block;
    width: 30px;
    text-align: center;
    cursor: pointer;
    i {
        vertical-align: middle;
    }
}
</style>
